module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "noticeCarousel",
    staticClass: "notice-carousel"
  }, [_c('div', {
    staticClass: "carousel-container",
    style: ({
      marginTop: -1 * _vm.activeIndex * _vm.carouselHeight + 'px',
      transition: 'all ' + _vm.transitonTime + 's ease-in-out'
    })
  }, _vm._l((_vm.noticeList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "flex",
      style: ({
        height: _vm.carouselHeight + 'px'
      })
    }, [_c('div', {
      staticClass: "notice-title flex-grow"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "notice-time"
    }, [_vm._v(_vm._s(item.createdAt.split(' ')[0]))])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fbc2b91","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NoticeCarousel.vue
// module id = 891
// module chunks = 1